<template>
  <div>
    <van-cell is-link :title="title" :value="textData[value] || '请选择'" @click="isShowPopup=true" />
    <van-popup v-model="isShowPopup" position="bottom" :close-on-click-overlay="false">
      <van-picker
        :title="`请选择${title||pickerTitle}`"
        show-toolbar
        :default-index="defaultIndex"
        :columns="columns"
        @confirm="confirm"
        @cancel="cancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { findEnumKey } from "@share/enum"

export default {
  props: {
    value: {
      type: [String, Number],
      default: undefined,
    },
    textData: {
      type: Object,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: undefined,
    },
    pickerTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowPopup: false,
      defaultIndex: 0,
    }
  },
  mounted() {
    this.defaultIndex = this.columns.findIndex(
      (item) => item === this.textData[this.value]
    )
  },
  methods: {
    confirm(e) {
      this.isShowPopup = false
      this.$emit("input", ~~findEnumKey(this.textData, e))
    },
    cancel(e) {
      this.isShowPopup = false
    },
  },
}
</script>
